module.exports = __webpack_public_path__ + "img/Dantam Hair 05.7e88ca69.jpg";